<template>
  <MetricTile
    :loading="loading"
    :no-data="!metric || !metric.completed"
    :options="{
      showAdditionalData: true
    }"
    icon="fa-regular fa-compass"
  >
    <template #title>{{ $t("components.HollandCodeCompletionRatioMetricTile.title") }}</template>
    <template #metric-title>{{ $t("components.HollandCodeCompletionRatioMetricTile.metric_title") }}</template>
    <template #metric>{{ metric.completed }}</template>
    <template #overMetric>{{ metric.total }}</template>
    <template #additionalMetric> {{ metric.percentage }}%</template>
    <template #info>{{ $t("components.HollandCodeCompletionRatioMetricTile.info") }}</template>
  </MetricTile>
</template>

<script setup lang="ts">
import MetricTile from "@/components/Metrics/MetricTile.vue";
import {useMetricTile} from "@/composables/useMetricTile";
const { metric, loading } = useMetricTile<
  {
    completed: number;
    total: number;
    percentage: number;
  }>("users-completed-holland-code-ratio");
</script>

<style scoped>

</style>
